import { Box } from "@mui/material";
import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material/styles";

import { DashMobileSectionHeader } from "./DashMobileSectionHeader";

interface DashMobileSectionProps {
  title?: string;
  subtitle?: string;
  onViewAll?: () => void;
  viewAllLabel?: string;
  action?: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
  /** Espaço superior entre seções do dash */
  spacingTop?: number;
}

/** Bloco de seção com ritmo visual consistente no dashboard mobile. */
export function DashMobileSection({
  title,
  subtitle,
  onViewAll,
  viewAllLabel,
  action,
  children,
  sx,
  spacingTop = 2.75,
}: DashMobileSectionProps) {
  return (
    <Box sx={{ mt: spacingTop, ...sx }}>
      {title ? (
        <DashMobileSectionHeader
          title={title}
          subtitle={subtitle}
          onViewAll={onViewAll}
          viewAllLabel={viewAllLabel}
          action={action}
        />
      ) : null}
      {children}
    </Box>
  );
}
